/**
 * Shared constants for UnitFields components
 */

export const NO_ACCESS_TO_CLASSIC_HELPER_TEXT = 'Disabled for current user, use Manager to change this';
